import { hotThreads } from "@/mocks/cg51";
import { Reveal, SectionHeading } from "./ui";

export default function HotThreads() {
  const [featured, ...rest] = hotThreads;
  return (
    <section id="hot" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <SectionHeading
              eyebrow="Hot Threads"
              title="热点专楼 · 一栋楼聊到天亮"
              desc="同一事件的前因后果、高赞回复与后续进展按时间收拢进一栋楼，直接点开顺着看就好，不用自己拼线索。"
            />
            <div className="flex flex-wrap items-center gap-2">
              {["全部", "内娱", "影视", "音乐", "电竞"].map((t, i) => (
                <button
                  key={t}
                  type="button"
                  className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                    i === 0 ? "bg-foreground-950 text-background-50" : "bg-background-50 text-foreground-700 hover:text-primary-700"
                  }`}
                >
                  {t}
                </button>
              ))}
              <button type="button" className="ml-1 inline-flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100">
                <i className="ri-refresh-line text-sm" /> 换一批
              </button>
            </div>
          </div>
        </Reveal>

        {/* 置顶大卡：文图对开 */}
        <Reveal className="mt-8">
          <a href="#hot" className="group grid overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200 lg:grid-cols-2">
            <div className="relative h-56 w-full overflow-hidden sm:h-72 lg:h-full">
              <img src={featured.img} alt={featured.title} title={`${featured.title} 热点专楼`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-fire-fill text-xs" /> {featured.badge}
              </span>
            </div>
            <div className="flex flex-col p-6 md:p-8">
              <div className="flex flex-wrap items-center gap-2 text-xs">
                <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900">
                  <i className="ri-grid-fill text-xs" /> {featured.zone}
                </span>
                <span className="text-foreground-500">{featured.updated}</span>
              </div>
              <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-2xl">{featured.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{featured.digest}</p>
              <div className="mt-auto flex flex-wrap items-center justify-between gap-3 pt-6">
                <span className="inline-flex items-center gap-1.5 text-sm text-foreground-600">
                  <i className="ri-chat-3-line text-base text-primary-600" /> {featured.replies} 条参与
                </span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700">
                  进入专楼 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </div>
          </a>
        </Reveal>

        {/* 其余小卡混排 */}
        <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((t, idx) => (
            <Reveal key={t.id} delay={idx * 80}>
              <a href="#hot" className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200">
                <div className="relative h-40 w-full overflow-hidden sm:h-44">
                  <img src={t.img} alt={t.title} title={`${t.title} 热点专楼`} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <span className="absolute right-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-foreground-950">
                    <i className="ri-fire-fill text-xs text-primary-600" /> {t.badge}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <span className="inline-flex w-fit items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                    {t.zone}
                  </span>
                  <h3 className="mt-3 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">{t.title}</h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-700">{t.digest}</p>
                  <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-chat-3-line text-sm" /> {t.replies}
                    </span>
                    <span>{t.updated}</span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}